@if (skill) {
  <app-detail-view [data]="skill" [title]="skill.skill" (closeClicked)="onCloseButtonClicked()">
    <div class="flex flex-col gap-4">
      <div>{{ 'team.size.plural' | translate: { persons: getTotalEmployees() } }}</div>

      <div class="flex flex-wrap gap-4">
        @for (stars of asKeyValuePairs(skillStats); track stars.key) {
          <div
            [class]="getStarContainerClass(stars.key)"
            (click)="starSelected(stars.key)"
            [attr.data-testid]="'skill-stars-' + stars.key">
            <gx-rating
              [rating]="parseInt(stars.key) + 1"
              activeRatingClass="--activeRating"
              inactiveRatingClass="--inactiveRating"></gx-rating>
            <div>({{ stars.value }})</div>
          </div>
        }
      </div>
      <div>
        <app-skill-employee-list
          [stars]="this.selectedStars"
          [skill]="skill.skill"
          [type]="skill.type">
        </app-skill-employee-list>
      </div>
    </div>
  </app-detail-view>
}
